import { Injectable, SkipSelf } from '@angular/core';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { EnvService } from 'src/app/env.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiEndPointsContact } from '../../common/apiUrls/api-end-points-contact';

@Injectable({
  providedIn: 'root'
})
export class ContacttService {
  private baseUrl:any;
  private baseUrlTran:any;
  private baseUrlClm:any;
  constructor(@SkipSelf()private _http: HttpClient, 
  private apiAddress: ApiEndPointsContact, public env: EnvService,
    private constant: Constants) {
      if( this.env.apiUrl==undefined  || this.env.apiUrl=='')
     this.baseUrl = this.constant.ManageCoreportNumber;
else
     this.baseUrl = this.env.apiUrl+this.constant.ManageCoreportNumber;
     if( this.env.apiUrl==undefined  || this.env.apiUrl=='')
     this.baseUrlTran = this.constant.ManageTranscationportNumber;
else
     this.baseUrlTran = this.env.apiUrl+this.constant.ManageTranscationportNumber;
     if( this.env.apiUrl==undefined  || this.env.apiUrl=='')
     this.baseUrlClm = this.constant.CustomizedGridComponentPortNumber;
else
     this.baseUrlClm = this.env.apiUrl+this.constant.CustomizedGridComponentPortNumber;
  }
    //private baseUrl1 = this.env.apiUrl1
    // private baseUrl = this.env.apiUrl+this.constant.ManageCoreportNumber;
    // private baseUrl = this.constant.ManageCoreportNumber;
    // private baseUrlClm = this.constant.CustomizedGridComponentPortNumber;
    // //private baseUrlClm = this.env.apiUrl+this.constant.CustomizedGridComponentPortNumber;
    // //private baseUrlTran = this.env.apiUrl+this.constant.ManageTranscationportNumber;
    // private baseUrlTran = this.constant.ManageTranscationportNumber;
    getContactList(reqModel): Observable<any> {
      const apiURL = this.baseUrlTran + this.apiAddress.getContactListing;
      return this._http.post(apiURL, reqModel).pipe();
    } 
    
    getContactFavoriteList(reqModel): Observable<any> {
      const apiURL = this.baseUrlTran + this.apiAddress.getFavoriteContactListing;
      return this._http.post(apiURL, reqModel).pipe();
    } 

    getFilteredContactsList(reqModel): Observable<any> {
      const apiURL = this.baseUrlTran + this.apiAddress.GetFilteredContacts;
      return this._http.post(apiURL, reqModel).pipe();
    }
   
    getContactUserDetails(reqModel): Observable<any> {
      const apiURL = this.baseUrlTran + this.apiAddress.getContactUserDetails;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getContactFeildList(reqModel): Observable<any> {
      const apiURL = this.baseUrl + this.apiAddress.getContactFeildList;
      return this._http.post(apiURL, reqModel).pipe();
    }

    geDefaultFilterFieldsList(reqModel): Observable<any> {
      const apiURL = this.baseUrlClm + this.apiAddress.getDefaultFilterFieldsList;
      return this._http.post(apiURL, reqModel).pipe();
    }

    CreateFilter(reqModel): Observable<any> {
      const apiURL = this.baseUrlClm + this.apiAddress.CreateFilter;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getImageUlpoadURL(reqModel): Observable<any> {
      const apiURL = this.baseUrlTran + this.apiAddress.getImageUploadURL;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getContactFieldColumnList(reqModel): Observable<any> {
      const apiURL = this.baseUrlClm + this.apiAddress.getContactFieldColumn;
      return this._http.post(apiURL, reqModel).pipe();
    }
 
    
    getAllContactTypeFilterList(reqModel): Observable<any> {
      const apiURL = this.baseUrlClm + this.apiAddress.GetAllFillters;
      return this._http.post(apiURL, reqModel).pipe();
    }

    updateContactFieldColumnList(reqModel): Observable<any> {
      const apiURL = this.baseUrlClm + this.apiAddress.updateContactFieldColumn;
      return this._http.post(apiURL, reqModel).pipe();
    }

    ReorderContactFieldColumnList(reqModel): Observable<any> {
      const apiURL = this.baseUrlClm + this.apiAddress.ReorderContactFieldColumn;
      return this._http.post(apiURL, reqModel).pipe();
    }

    saveContactFeildList(reqModel): Observable<any> {
      const apiURL = this.baseUrlTran + this.apiAddress.saveContactFieldList;
      return this._http.post(apiURL, reqModel).pipe();
    }
    saveContactUserDetails(reqModel): Observable<any> {
      const apiURL = this.baseUrlTran + this.apiAddress.saveContactUserDetails;
      return this._http.post(apiURL, reqModel).pipe();
    }

    DeleteContactTransaction(reqModel): Observable<any> {
      const apiURL = this.baseUrlTran + this.apiAddress.DeleteContactTransaction;
      return this._http.post(apiURL, reqModel).pipe();
    }

    FavoriteContactTransaction(reqModel): Observable<any> {
      const apiURL = this.baseUrlTran + this.apiAddress.FavoriteContactTransaction;
      return this._http.post(apiURL, reqModel).pipe();
    }

    FavoriteDeleteContactTransaction(reqModel): Observable<any> {
      const apiURL = this.baseUrlTran + this.apiAddress.FavoriteDeleteContactTransaction;
      return this._http.post(apiURL, reqModel).pipe();
    }
}
